import React from 'react';
import cx from 'classnames';

const WidgetWrapper = ({ type = 'generic', children }) => {
  const classes = cx('cms-widget-wrapper', `cms-widget-wrapper--${type}`);
  return <div className={classes}>{children}</div>;
};
export default WidgetWrapper;
